import styled from "styled-components";

export const Congratulation = styled.div`
  width: 78vw;
  height: 98vh;
  display: flex;
  align-items: center;
  padding-left: 48px;
  @media screen and (min-width: 750px) {
    padding-left: 150px;
  }
`;
export const Description = styled.div`
  font-family: "Zilla Slab Highlight", cursive;
  color: #fff;
  font-size: 2.5rem;
  user-select: none;
  height: 100px;
  width: 429px;
  @media screen and (min-width: 750px) {
    font-size: 35px;
  }
`;
